<ptl-v3-content-card [item]="cardItem()" view="list" [action]="action()" (cardClicked)="onCardOpen()" (actionClicked)="onCardOpen()">
</ptl-v3-content-card>
